module.exports = __webpack_public_path__ + "static/media/how_lt.a68b1168.vtt";